<template>
  <editable-box
    ref="editableBox"
    :mode="mode"
    :includeBtns="['drag', 'setup', 'delete', 'add']"
    @onAdd="handelAdd"
    @onDelete="handelDelete"
    @onSetup="handleEditData"
  >
    <div class="radar-box">
      <div class="radar-chats" ref="radarCharts" v-if="showCharts"></div>
      <div class="edit-data" @click="handleEditData" v-else-if="mode === 'edit'">
        <div class="icon">
          <i class="iconfont icon-tianjia"></i>
        </div>
        <div class="desc">设置维度</div>
      </div>
      <!-- 设置 -->
      <edit-panel
        v-if="mode === 'edit'"
        ref="editPanel"
        :isShowTabs="isShowTabs"
        :tabs="tabs"
        :data="data"
        @onChange="handleItemEdit"
      ></edit-panel>
    </div>
  </editable-box>
</template>

<script>
// components
import EditableBox from "../../../../components/EditableBox/index.jsx";
import EditPanel from "./EditPanel";
import { loadScript } from "@/plugins/util";
const chartsOptions = {
  legend: {
    data: []
  },
  radar: {
    // shape: 'circle',
    indicator: [],
    axisName: {
      color: "#1D2129"
    },
    splitArea: {
      show: false
    }
  },
  series: [
    {
      name: "雷达图",
      type: "radar",
      areaStyle: {
        opacity: 0.1
      },
      label: {
        color: "#1D2129"
      },
      itemStyle: {
        borderColor: "#fff",
        borderWidth: 1
      },
      data: []
    }
  ]
};
export default {
  name: "RadarBox",
  components: {
    EditableBox,
    EditPanel
  },
  props: {
    mode: String,
    data: {
      type: Object,
      default: () => ({})
    },
    isShowTabs: {
      type: Boolean,
      default: false
    },
    tabs: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      showCharts: false
    };
  },
  watch: {
    data: {
      handler(val) {
        this.checkShowCharts();
      },
      deep: true
    }
  },
  mounted() {
    this.checkShowCharts();
  },

  methods: {
    checkShowCharts() {
      if (typeof window !== "undefined") {
        let isShow = true;
        this.data.radarIndicator.forEach((item, index) => {
          if (index < 5) {
            if (!item.name) {
              isShow = false;
            }
          }
        });

        this.showCharts = isShow;
        if (isShow) {
          setTimeout(() => {
            this.importInitEcharts();
          }, 200);
        }
      }
    },
    importInitEcharts() {
      // 被裁减的echarts 包含雷达图
      loadScript(`${process.env.VUE_APP_CDN_BASE}dist/static/echarts.min.js?t=10001`).then(() => {
        const echarts = window.echarts;
        this.initChats(echarts);
      });
    },
    initChats() {
      const chartsContainer = this.$refs.radarCharts;
      let myChart = echarts.init(chartsContainer);
      let show = false;
      chartsOptions.radar.indicator = this.data.radarIndicator
        .filter((item, index) => {
          if (index === 5) {
            show = !!item.name;

            return show;
          }
          return true;
        })
        .map((item, index) => {
          return {
            name: item.name,
            max: 10,
            axisLabel: { show: index === 0, color: "#1D2129", fontSize: 10, align: "center" }
          };
        });
      chartsOptions.series[0].data = this.data.radarData
        .filter((item, index) => {
          if (index === 5) {
            return show;
          }
          return true;
        })
        .map(item => {
          return {
            name: item.name,
            value: item.value
          };
        });
      // 绘制图表
      myChart.setOption(chartsOptions);
    },
    handelAdd() {
      this.$emit("onAdd");
    },
    handelDelete() {
      this.$emit("onDelete");
    },
    handleEditData() {
      this.$refs.editPanel.open();
    },
    handleItemEdit(data) {
      this.$emit("onChange", data);
    }
  }
};
</script>

<style lang="less" scoped>
.radar-box {
  display: flex;
  flex-direction: column;
  min-width: 80px;
  min-height: 80px;
  .edit-data {
    width: 514px;
    height: 432px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: 1px solid rgba(122, 147, 172, 0.12);
    border-radius: 8px;
    .icon {
      width: 32px;
      height: 32px;
      text-align: center;
      line-height: 32px;
      font-size: 18px;
      margin-bottom: 6px;
      color: #333;
    }
    .desc {
      text-align: center;
      font-size: 12px;
      font-weight: 400;
      color: #333;
      line-height: 17px;
    }
  }

  .radar-chats {
    width: 514px;
    height: 432px;
  }
}
</style>
